import InstructionsForm from './InstructionsForm';

export default InstructionsForm;
